import { render, staticRenderFns } from "./UIHomepageBackButton.vue?vue&type=template&id=fef07944&functional=true&"
import script from "./UIHomepageBackButton.vue?vue&type=script&lang=js&"
export * from "./UIHomepageBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports